import styled, { css } from 'styled-components';
import type { MinWidthBreakpoint } from '#/shared/constants';

/**
 * You can pass either visible or visibleAt - not both.
 * If visible is true screen reader text will be visible.
 * visibleAt is min-width breakpoint at which the previously screenreader-only text should be made visible.
 * */
type ScreenReaderTextProps =
  | { visible?: boolean; visibleAt?: never }
  | { visibleAt?: MinWidthBreakpoint; visible?: never };

export const screenReaderOnlyTextStyles = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  border: 0;
`;

export const screenReaderTextVisibleStyles = css`
  /* 
   * When resizing the screen in Safari, if the parent is display: flex; Safari glitches 
   * due to the absolute positioning set above. Adding display: flex here forces a box recalculation
   * so the width of the parent gets set correctly 
   */
  display: flex;
  position: unset;
  width: unset;
  height: unset;
  padding: unset;
  margin: unset;
  overflow: unset;
  clip: unset;
  clip-path: unset;
  border: unset;
`;

export const ScreenReaderText = styled.span<ScreenReaderTextProps>`
  ${screenReaderOnlyTextStyles}

  ${({ visible = false, visibleAt }) => {
    if (visible) return screenReaderTextVisibleStyles;

    if (visibleAt)
      return css`
        @media (min-width: ${visibleAt}) {
          ${screenReaderTextVisibleStyles}
        }
      `;

    return null;
  }}
`;
